import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EnterScore from "./EnterScore";
import ShowScore from "./ShowScore";

const JudgeCompiPage = () => {
  const params = useParams();
  const { compId } = params;
  const navigate = useNavigate();

  const [parameters, setParameters] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [competition, setCompetition] = useState({});
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  const fetchCompiDetails = () => {
    Axios.get(
      `https://ashish.moodi.org/multicity/get_compi_details?id=${compId}`
    )
      .then((res) => setCompetition(res.data))
      .catch((err) => console.error(err));
  };

  const fetchParameters = () => {
    Axios.get(
      `https://ashish.moodi.org/multicity/get_mul_parameters?id=${compId}`
    )
      .then((res) => setParameters(res.data))
      .catch((err) => console.error(err));
  };

  const fetchParticipants = () => {
    Axios.get(
      `https://ashish.moodi.org/multicity/get_mul_participants?id=${compId}`
    )
      .then((res) => setParticipants(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("judgeauthtoken")) {
      fetchCompiDetails();
      fetchParameters();
      fetchParticipants();
      setLoading(false); // Set loading to false once data is fetched
    } else {
      navigate("/judge/login");
    }
    // eslint-disable-next-line
  }, [compId, navigate]);

  // Add a loading message while data is being fetched
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container-fluid">
      <h2>{competition.mcName} - Score Sheet</h2>
      <EnterScore
        comp_id={compId}
        parameters={parameters}
        participants={participants}
        scores={scores}
        setScores={setScores}
      />
      <ShowScore
        comp_id={compId}
        parameters={parameters}
        participants={participants}
        scores={scores}
        setScores={setScores}
      />
    </div>
  );
};

export default JudgeCompiPage;
